import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';
import { Button } from '@lyse-as/formds-react';

import { SmallContainer } from 'src/components/container';
import { Image } from 'src/components/image';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { spacing1, spacing13, spacing3, spacing4, spacing5, spacing8 } from 'src/styles/spacing';

export const StyledContainer = styled(SmallContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: ${spacing4};
  margin-bottom: ${spacing8};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-top: ${spacing13};
  }
`;

export const StyledImage = styled(Image)`
  padding-top: ${spacing5};
  margin-bottom: ${spacing5};
  max-height: 64px;

  @media (min-width: ${breakpointTablet}) {
    padding-top: ${spacing8};
    max-height: 80px;
  }
`;

export const StyledButton = styled(Button)`
  margin: ${spacing1} 0;

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing4};
    margin-bottom: ${spacing3};
  }
`;

export const StyledSubtitle = styled(Typography)`
  padding-bottom: ${spacing4};
  text-align: left;

  @media (min-width: ${breakpointTablet}) {
    padding-bottom: ${spacing5};
    text-align: center;
  }
`;
